module.exports = __webpack_public_path__ + "static/media/Asset 3_6.ccbe30aa.png";